import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { DataFieldType } from '../../data-field-type';
import { DataFieldModel } from '../../data-field.model';
import { DataFieldGroupEditItemService } from '../data-field-group-edit.service';
import { FocusMonitor } from '@angular/cdk/a11y';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

@Component({
    selector: 'fi-data-field-group-edit-item',
    templateUrl: './group-item.component.html',
    styleUrls: ['./group-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-data-field-group-edit-item' },
    standalone: false,
})
export class DataFieldGroupEditItemComponent implements AfterViewInit {
    @Input() item: DataFieldModel;
    @Input() activeItem: number;
    @Input() selectedLanguage: IContentLanguage;
    @Input() isDragDisabled: boolean = false;

    @ViewChild('editButton', { read: ElementRef, static: false }) editButtonRef: ElementRef;

    private defaultLanguageId: number;

    constructor(
        private dataFieldGroupEditItemService: DataFieldGroupEditItemService,
        private _focusMonitor: FocusMonitor,
        private customerDataService: FiCustomerDataService,
        private cdr: ChangeDetectorRef,
    ) {
        this.defaultLanguageId = this.customerDataService.customerData.DefaultApplicationLanguageType;
    }

    getDataFieldName(dataField: DataFieldModel, activeLanguageId) {
        const nameLabel = dataField.Names.find((n) => n.ContentLanguageId == activeLanguageId);
        if (nameLabel && nameLabel.Value) return nameLabel.Value;

        const defaultLabel = dataField.Names.find((n) => n.ContentLanguageId == this.defaultLanguageId);
        if (defaultLabel && defaultLabel.Value) return defaultLabel.Value;

        return '';
    }

    getDataFieldType(dataField: DataFieldModel) {
        if (dataField.Type == DataFieldType.Text) return 'data_field.text_type';
        if (dataField.Type == DataFieldType.Numeric) return 'data_field.numeric_type';
        if (dataField.Type == DataFieldType.Calendar) return 'data_field.calendar_type';
        if (dataField.Type == DataFieldType.PreSetOptions) return 'data_field.pre_set_options_type';
        throw new Error('unknown DataFieldType');
    }

    isShowEditField(item: DataFieldModel) {
        return !item.IsMandatory;
    }

    editFieldClick(item) {
        this.dataFieldGroupEditItemService
            .handleEditItem(item, this.selectedLanguage)
            .then(() => this.cdr.detectChanges());
    }

    ngAfterViewInit() {
        if (this.editButtonRef) this._focusMonitor.stopMonitoring(this.editButtonRef.nativeElement);
    }
}
